var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enter-bout"},[_c('h1',[_vm._v("Enter a new bout")]),_c('boutform',{attrs:{"competitors":_vm.competitors,"events":_vm.events,"me":_vm.me}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }